import { Clock, Flower2, Landmark, Plane, TreePine } from "lucide-react";
import Reveal from "./Reveal";
import { ATTRACTIONS } from "../data/content";

const TILE_ICONS = [Flower2, Landmark, Plane, TreePine];

const Attractions = () => {
  const featured = ATTRACTIONS.slice(0, 2);
  const tiles = ATTRACTIONS.slice(2);
  return (
    <section id="explore" data-testid="attractions-section" className="border-t border-[#2A2421] bg-[#161311] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="mb-14 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <p className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#C5A059]">Paradise on Earth</p>
              <h2 className="mt-4 font-display text-4xl font-light text-[#F5F2EB] sm:text-5xl">Explore Srinagar</h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-[#A8A29E]">
              Perfectly placed on Hyderpora Bypass — minutes from the airport, the lake and the gardens. Our concierge
              arranges shikaras, gondolas and day trips.
            </p>
          </div>
        </Reveal>

        <div className="grid gap-6 lg:grid-cols-2">
          {featured.map((a, i) => (
            <Reveal key={a.name} delay={i * 0.12}>
              <figure data-testid={`attraction-featured-${i}`} className="group relative aspect-[16/10] overflow-hidden border border-[#2A2421]">
                <img
                  src={a.image}
                  alt={a.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D0B0A]/90 via-transparent to-transparent" />
                <span className="absolute right-4 top-4 flex items-center gap-1.5 border border-[#C5A059]/50 bg-[#0D0B0A]/70 px-3 py-1.5 text-[10px] uppercase tracking-[0.2em] text-[#C5A059] backdrop-blur-md">
                  <Clock size={11} /> {a.time}
                </span>
                <figcaption className="absolute bottom-0 p-6">
                  <h3 className="font-display text-2xl text-[#F5F2EB]">{a.name}</h3>
                  <p className="mt-1 text-sm text-[#D6CDBE]">{a.text}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-px border border-[#2A2421] bg-[#2A2421] sm:grid-cols-2 lg:grid-cols-4">
          {tiles.map((a, i) => {
            const Icon = TILE_ICONS[i];
            return (
              <Reveal key={a.name} delay={i * 0.08}>
                <div data-testid={`attraction-tile-${i}`} className="h-full bg-[#0D0B0A] p-7 transition-colors duration-500 hover:bg-[#161311]">
                  <Icon size={22} strokeWidth={1.4} className="text-[#C5A059]" />
                  <h3 className="mt-4 font-display text-lg text-[#F5F2EB]">{a.name}</h3>
                  <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#8C713B]">{a.time}</p>
                  <p className="mt-2 text-sm leading-relaxed text-[#A8A29E]">{a.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Attractions;
